import { render, staticRenderFns } from "./ddSelect.vue?vue&type=template&id=274d5bab"
import script from "./ddSelect.vue?vue&type=script&lang=js"
export * from "./ddSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports